const plans = [
  {
    key: 'one-month',
    per: '1 Bulan',
    description: 'Ideal untuk pemula',
    price: '250.000',
  },
  {
    key: 'two-months',
    per: '2 Bulan',
    description: 'Untuk yang siap berinvestasi',
    price: '200.000',
  },
  {
    key: 'three-months',
    per: '3 Bulan',
    description: 'Favorit investor di Stockbit',
    price: '150.000',
  },
  {
    key: 'free',
    per: 'Free',
    description: 'Dengan membuka akun trading di Stockbit',
    price: 0,
  },
];

export default plans;
